let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gOlh9")).then(() => parcelRequire('8fhBi'));